import axios from 'axios'
import { getToken, removeToken } from '../utils/auth'
import store from '@/store/index'
import { createToastInterface } from "vue-toastification"
import { $themeConfig } from '@themeConfig'


// create an axios instance
const service = axios.create({
  baseURL: $themeConfig.app.apiUrl+'/api/v1', //api请求地址
  timeout: 5000                                  //响应等待时间
})
const toast = createToastInterface({
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
})

// request interceptor
service.interceptors.request.use(
  config => {
    //if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
   // }
   
    if(config.type == 'formData'){
      config.headers['Content-Type'] = 'multipart/form-data'
      let formdata = new FormData();
      for (let v in config.data) {
        formdata.append(v, config.data[v]);
      }
      config.data = formdata
    }
	else if(config.type == 'download'){
	  config.responseType = 'blob'
	  config.headers['Access-Control-Expose-Headers'] = 'Content-Disposition';
	}
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
	let res = response.data	 
	if(res.status!=undefined && (res.status==401 || res.status==500)){
	  toast.error(res.message);
	}
	
	if(response.config.type=='download'){
	  res = response  	
	}  
    return res
  },
  error => {
    //登录验证不通过
    if (error.response.status == 401) {
	  toast.error('会话已过期,请重新登录');	
      store.dispatch('user/logout').then(() => {
        location.reload()
      })
    }
    return Promise.reject(error);
  }
)

export default service
